import React, { useState, useEffect,useRef } from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import { useAppSelector } from "hooks/store/hooks";
import { selectColorThemeMode } from "stores/ui/uiSlice";
import MobileGreenIcon from "components/Icons/TobarIcons/MobileGreenIcon";
import MobileYellowIcon from "components/Icons/TobarIcons/MobileYellowIcon";
import MobileGreyIcon from "components/Icons/TobarIcons/MobileGreyIcon";
import MobileRedIcon from "components/Icons/TobarIcons/MobileRedIcon";
import { getAuthToken, getUserDetails } from "utils/local-storage";
import { useDispatch } from "react-redux";
import { setWebSocketMessage} from "stores/webSocket/websocketSlice";
import { selectCurrentDevice, } from "stores/auth/authSlice";
import { getAPIURL, } from "utils/misc";
import moment from "moment";
import PhotosGalleryImageComponent from "pages/QuickAccessBarViewComponentPage/PhotosGalleryImageComponent";
import calls from "components/Icons/QuickAccessBarIcons/calls.svg";
import photo from "components/Icons/QuickAccessBarIcons/photo.svg";
import sms from "components/Icons/QuickAccessBarIcons/sms.svg";
import WindowsGreenIcon from "components/Icons/TobarIcons/WindowsGreenIcon";
import WindowsYellowIcon from "components/Icons/TobarIcons/WindowsYellowIcon";
import WindowsGreyIcon from "components/Icons/TobarIcons/WindowsGreyIcon";
import WindowsRedIcon from "components/Icons/TobarIcons/WindowsRedIcon";
import MacGreenIcon from "components/Icons/TobarIcons/MacGreenIcon";
import MacYellowIcon from "components/Icons/TobarIcons/MacYellowIcon";
import MacGreyIcon from "components/Icons/TobarIcons/MacGreyIcon";
import MacRedIcon from "components/Icons/TobarIcons/MacRedIcon";
import CallIncomingIcon from "components/Icons/QuickAccessBarIcons/CallIncomingIcon";
import CallOutgoingCall from "components/Icons/QuickAccessBarIcons/CallOutgoingCall";
import CallMissedCallIcon from "components/Icons/QuickAccessBarIcons/CallMissedCallIcon";
import CallReceivedIcon from "components/Icons/QuickAccessBarIcons/CallReceivedIcon";

const NotificationPanel = ({ content, currentDevice1 }) => {
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const authToken = getAuthToken();
  const dispatch = useDispatch();
  const currentDevice = useAppSelector(selectCurrentDevice);
  const [messageQueue, setMessageQueue] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const wsRef = useRef(null);
  const userDetails = getUserDetails();

  useEffect(() => {

    const now = Date.now(); // current timestamp in ms
    const expiryTime = new Date(userDetails?.token_expiry).getTime(); // expiry in ms

    if (now > expiryTime) {
      console.log("Token expired. WebSocket not connecting.");
      return; // stop execution
    }

    // This will hold the current WebSocket connection
    let ws = wsRef.current;
    let reconnectTimer = null;
    let pingInterval = null;
  
    // Function to establish a WebSocket connection
    const connectWebSocket = () => {
      // If already connected, don't reconnect
      if (ws && ws.readyState === WebSocket.OPEN) return;
  
      const base64Token = btoa(authToken).replace(/=/g, "");
      const subprotocols = [
        `base64url.bearer.authorization.k8s.io.${base64Token}`,
        "base64.binary.k8s.io",
      ];
  
     // Create a new WebSocket connection
      // below url making for  Huwaei Device Specificitions 

      const WebsocketapiUrl = getAPIURL().replace(/^https?/, "wss");
      ws = new WebSocket(`${WebsocketapiUrl}/register/177`, subprotocols);
      wsRef.current = ws;
  
      ws.onopen = () => {
        console.log("WebSocket connected");
  
        // Clear any pending reconnect timer
        if (reconnectTimer) clearTimeout(reconnectTimer);
  
        // Send a ping every 30 seconds to keep the connection alive
        pingInterval = setInterval(() => {
          if (ws.readyState === WebSocket.OPEN) {
            ws.send(JSON.stringify({ type: "ping" }));
          }
        }, 30000);  // Ping interval (30 seconds)
      };
  
      ws.onmessage = (event) => {
        console.log("Received:", event.data);
        setMessageQueue((prevQueue) => [
          ...prevQueue,
          { ...JSON.parse(event.data), id: Date.now(), isVisible: false },
        ]);
        dispatch(setWebSocketMessage({ messages: JSON.parse(event.data) }));
      };
  
      ws.onerror = (error) => {
        console.error("WebSocket error:", error);
      };
  
      ws.onclose = () => {
        console.log("WebSocket closed. Reconnecting in 6 second...");
        clearInterval(pingInterval); // Clear ping interval on close
        reconnectTimer = setTimeout(connectWebSocket, 6000); // Reconnect after **1 second**
      };
    };
  
    // Initiate WebSocket connection
    connectWebSocket();
  
    // Cleanup function to close WebSocket and clear timers
    // return () => {
    //   if (ws) ws.close();
    //   clearTimeout(reconnectTimer);
    //   clearInterval(pingInterval); // Clean up ping interval
    // };
  
  }, [authToken]);  // Dependency on authToken to restart connection when token changes  
  
  
  // Handle message visibility animation and removal
 
  useEffect(() => {
    if (!isProcessing && messageQueue.length > 0) {
      setIsProcessing(true);
  
      const showMessage = () => {
        setMessageQueue((prevQueue) =>
          prevQueue.map((msg, index) =>
            index === 0 ? { ...msg, isVisible: true } : msg
          )
        );
  
        setTimeout(() => {
          setMessageQueue((prevQueue) => prevQueue.slice(1));
          setIsProcessing(false);
        }, 8000); // Duration for animation
      };
  
      showMessage();
    }
  }, [messageQueue, isProcessing]);
  
 
  const getStatusIcon = (family, statusColor) => {
    const icons = {
      1: {
        green: <MobileGreenIcon />,
        yellow: <MobileYellowIcon />,
        grey: <MobileGreyIcon />,
        red: <MobileRedIcon />,
      },
      7: {
        green: <WindowsGreenIcon />,
        yellow: <WindowsYellowIcon />,
        grey: <WindowsGreyIcon />,
        red: <WindowsRedIcon />,
      },
      11: {
        green: <MacGreenIcon />,
        yellow: <MacYellowIcon />,
        grey: <MacGreyIcon />,
        red: <MacRedIcon />,
      },
    };

    return icons[family]?.[statusColor] || null;
  };

//console.log(messageQueue,"messageQueue from event list");

  const animationStyles = `
    @keyframes bubbleAnimation {
      0% {
        transform: translateY(100%); /* Start off-screen at the bottom */
        opacity: 1;
      }
      37.5% {
        transform: translateY(0); /* Center of the screen */
        opacity: 1;
      }
      62.5% {
        transform: translateY(0); /* Pause for 5 seconds */
        opacity: 1;
      }
      100% {
        transform: translateY(-100%); /* Move off-screen at the top */
        opacity: 0;
      }
    }
  `;

  return (
    <>
      <style>{animationStyles}</style>
      {messageQueue.length > 0 && messageQueue[0].isVisible && (
  <Box
    key={messageQueue[0].id}
    position="fixed"
    bottom="0"
    left="-10px"
    right="0"
    top="0"
    color="white"
    w="100%"
    display="flex"
    alignItems="center"
    justifyContent="right"
    textAlign="center"
    animation="bubbleAnimation 8s ease-in-out forwards"
    zIndex="2000"
    pointerEvents="none"
  >
    <Box
      bg={`${colorThemeMode}_background`}
      borderRadius="md"
      boxShadow="lg"
      w="300px"
      pointerEvents="auto" 
    >
      <Box display="flex" justifyContent="space-between" ms="10px" padding="8px">
        <Box display="flex" alignItems="center">
          <Box
            color={`${colorThemeMode}_text`}
            borderRadius="50px"
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {getStatusIcon(currentDevice.family, "green")}
          </Box>
          <Text mt="3px" ml="10px" color={`${colorThemeMode}_text`} fontSize="14px" fontWeight="400">
            {messageQueue[0].popup.friendlyname}
          </Text>
        </Box>
        <Text mt="5px" mr="5px" fontSize="14px" color="gray.500">
          {moment(Number(messageQueue[0].popup.time)).format("hh:mm A")}
        </Text>
      </Box>
      <Box
        display="flex"
        alignItems="center"
        color={`${colorThemeMode}_text`}
        w="100%"
        borderTop={"1px solid"}
        borderColor={`${colorThemeMode}_tertiary`}
        padding="10px"
      >
        <Image
          borderRadius="full"
          boxSize="60px"
        //  src={`${process.env.REACT_APP_API_URL}api/pkglist/cthumb?pkgid=${messageQueue[0].popup.marketid === "" ? messageQueue[0].popup.name : messageQueue[0].popup.marketid}`}
          src={messageQueue[0].popup.marketid === "com.calllog" ? calls 
          : messageQueue[0].data?.hasOwnProperty("photo") ? photo
          : messageQueue[0].data?.hasOwnProperty("sms") ? sms
          : `${getAPIURL()}api/pkglist/cthumb?pkgid=${messageQueue[0].popup.marketid === "" ? messageQueue[0].popup.name 
          : messageQueue[0].popup.marketid}`}
         bg="blackAlpha.200"
          p="5px"
        />
        <Box display="flex" flexDirection={messageQueue[0].popup.file && /\.(png|jpg|gif|3gp)$/.test(messageQueue[0].popup.file) ? 'row' : 'column'}>
          <Box pl="10px" display="flex" alignItems="center">
            <Text fontSize="15px" fontWeight="600">
              {messageQueue[0].popup.name.replace(/&quot;/g, '"')
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/%2B/g, " ")}
            </Text>
          </Box>
           <Box pl="10px" mt="5px" color="gray.500">
         {messageQueue[0].popup.file && /\.(png|jpg|gif|3gp)$/.test(messageQueue[0].popup.file) ? null : (  
              messageQueue[0].popup.content && (
                ![".mp3", ".amr", ".wav", ".opus", ".ogg", ".3gp"].some(ext => messageQueue[0].popup.content.endsWith(ext)) ? (
                    (
                    <Text textAlign="start">
                    {messageQueue[0].popup.content.length > 28 ? `${messageQueue[0].popup.content.substring(0, 28)}...` : messageQueue[0].popup.content}
                  </Text>
                )
                ) : messageQueue[0].popup.file && messageQueue[0].popup.file.endsWith(".mp4") ? (
                <Text textAlign="start">🎥 You have received new Video Recording</Text>
                ) : (
                <Text textAlign="start">🎤 You have received new Voice Message</Text>
                )
              )
            )} 
                 {messageQueue[0].popup.marketid === "com.calllog" ? (
            <Box display="flex" alignItems="center" gap="8px">
              {messageQueue[0].popup.type === 1 && <CallIncomingIcon />}
              {messageQueue[0].popup.type === 2 && <CallOutgoingCall />}
              {messageQueue[0].popup.type === 3 && <CallMissedCallIcon />}
              {messageQueue[0].popup.type === 5 && <CallReceivedIcon />}
              <Text>{`${messageQueue[0].popup.duration}s`}</Text>
            </Box>
          ) : null}
       
            {messageQueue[0].popup.file  && !messageQueue[0].popup.file.endsWith(".opus") ? (
              <Text mt="5px" display="flex" justifyContent="end">
                <PhotosGalleryImageComponent
                  imei={messageQueue[0].popup.imei}
                  src={`${getAPIURL()}api/files/downloadfile/${messageQueue[0].popup.imei}?filename=thumbnail/${messageQueue[0].popup.file}&t=${messageQueue[0].popup.time}`}
                  boxSize="70px"
                />
              </Text>
            ) : null}
          </Box> 
        </Box>
      </Box>
    </Box>
  </Box>
)}

    </>
  );
};

export default NotificationPanel;
